export default __webpack_public_path__ + "static/media/material_table.e61eaa0b.svg";